import { useEffect } from 'react';

export default function ConfirmModal({ title, message, confirmLabel = 'Confirm', confirmIcon, cancelLabel = 'Cancel', danger = false, disabled = false, onConfirm, onCancel }) {
  useEffect(() => {
    const handleKey = (e) => { if (e.key === 'Escape' && onCancel) onCancel(); };
    document.addEventListener('keydown', handleKey);
    return () => document.removeEventListener('keydown', handleKey);
  }, [onCancel]);

  return (
    <div className="confirm-modal-overlay" onMouseDown={onCancel || undefined}>
      <div className="confirm-modal" onMouseDown={(e) => e.stopPropagation()}>
        {title && <h3 className="confirm-modal-title">{title}</h3>}
        {message && <p className="confirm-modal-message">{message}</p>}
        <div className="confirm-modal-buttons">
          <button className={`btn ${danger ? 'btn-danger' : 'btn-primary'}`} onClick={onConfirm} disabled={disabled}>
            {confirmIcon || confirmLabel}
          </button>
          {onCancel && (
            <button className="btn btn-outline" onClick={onCancel}>
              {cancelLabel}
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
